import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=33e020a4&"
import script from "./user-menu.vue?vue&type=script&lang=js&"
export * from "./user-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports